import { useMemo } from 'react';
import { parseHtml } from 'containers/app/helpers/parseHtml';

const useParseHtml = html => useMemo(() => parseHtml(html, true), [html]);

export default useParseHtml;
